import {
    FontColorsOutlined,
} from "@ant-design/icons";
import { lazy } from "react";

export const sensorStaticPath = {
    sensor: "/sensor",
    sensorCreate: "/sensor/them-moi",
    sensorUpdate: "/sensor/cap-nhat",
    assetMaintenanceMappingSensor: "/sensor/asset-maintenance-mapping-sensor",
    sensorMonitoring: "/sensor/sensor-monitoring"

};

export const routeSensors = [
    {
        key: sensorStaticPath.sensor,
        path: sensorStaticPath.sensor,
        exact: true,
        show_menu: true,
        icon: <FontColorsOutlined />,
        label: "Quản lý cảm biến",
        component: lazy(() => import("../pages/sensor")),
        un_check_permission: true, // đợi làm xong rồi check lại
    },
    {
        key: sensorStaticPath.sensorCreate,
        path: sensorStaticPath.sensorCreate,
        exact: true,
        show_menu: false,
        icon: <FontColorsOutlined />,
        label: "",
        component: lazy(() => import("../pages/sensor/CreateSensor")),
        un_check_permission: true, // đợi làm xong rồi check lại
    },
    {
        key: sensorStaticPath.sensorUpdate + "/:id",
        path: sensorStaticPath.sensorUpdate + "/:id",
        exact: true,
        show_menu: false,
        icon: <FontColorsOutlined />,
        label: "",
        component: lazy(() => import("../pages/sensor/UpdateSensor")),
        un_check_permission: true, // đợi làm xong rồi check lại
    },
    {
        key: sensorStaticPath.assetMaintenanceMappingSensor + "/:id",
        path: sensorStaticPath.assetMaintenanceMappingSensor + "/:id",
        exact: true,
        show_menu: false,
        icon: <FontColorsOutlined />,
        label: "",
        component: lazy(() => import("../pages/sensor/assetMaintenanceMappingSensor")),
        un_check_permission: true, // đợi làm xong rồi check lại
    },
    {
        path: sensorStaticPath.sensorMonitoring,
        key: sensorStaticPath.sensorMonitoring,
        exact: true,
        title: "Theo dõi cảm biến",
        show_menu: false,
        icon: <FontColorsOutlined />,
        component: lazy(() => import("../pages/sensor/sensorMonitoring")),
        un_check_permission: true,
    },
    //  {
    //     key: sensorStaticPath.assetMaintenanceMappingSensor + "/:id",
    //     path: sensorStaticPath.assetMaintenanceMappingSensor + "/:id",
    //     exact: true,
    //     show_menu: false,
    //     icon: <FontColorsOutlined />,
    //     label: "",
    //     component: lazy(() => import("../pages/sensor/assetMaintenanceMappingSensor")),
    //     un_check_permission: true, // đợi làm xong rồi check lại
    // },

];
